const StaffEntryComponent = () => import('@/views/hrm/StaffEntry/StaffEntryView')

export default [
    {
        path:'/StaffEntryIndex',
        name:'StaffEntryComponent',
        component:StaffEntryComponent
    }
]